import React from 'react';
import { Box, Typography } from '@mui/material';

const Logo = ({ color = 'white', textStyles = {}, containerStyles = {} }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', ...containerStyles }}>
      <Typography
        variant="h1"
        sx={{
          fontFamily: "'Playfair Display', serif",
          fontSize: { xs: '2.5rem', md: '3rem' },
          fontWeight: 700,
          color: color,
          textShadow: '0 2px 4px rgba(0,0,0,0.1)',
          letterSpacing: '0.02em',
          ...textStyles,
        }}
      >
        pathly
      </Typography>
      <Box
        sx={{
          position: 'relative',
          left: '-5px',
          top: '-15px',
          width: '22px',
          height: '22px',
          bgcolor: 'black',
          clipPath: 'polygon(100% 50%, 0 0, 25% 50%, 0 100%)',
          transform: 'rotate(-55deg)',
        }}
      />
    </Box>
  );
};

export default Logo; 